/** Lowercase without accents, for searching ("Botiquín" matches "botiquin"). */
export function normaliseText(text: string): string {
  return text
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase();
}
